import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@domain/api';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuditTrailService {
  constructor(private http: HttpClient) {}

  /**
   * Generic method to get audit trail for any entity type
   * @param entityType Type of entity (e.g., 'slaughterhouse', 'haulier', 'byproduct')
   * @param entityId Entity ID
   */
  async getAuditTrail<T>(entityType: string, entityId: string) {
    return firstValueFrom(this.http.get<ApiResponse<T[]>>(`/api/audit/${entityType}/${entityId}`));
  }
}
